import axios from 'utils/axios-interceptor';
import { API_URL } from 'constants/config';
import ls from 'localstorage-slim';
// enable global encryption
ls.config.encrypt = true;

// get all questions
export const getVettingPoolList = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('token') || payload?.token}`,
    organisationid: ls.get('orgId') || payload.orgId,
  };
  const query = {
    search: payload.search_keyword ? payload.search_keyword : '',
    sort: payload.sort,
    sortBy: payload.sortBy,
    currentPage: payload.currentPage,
    perPage: payload.perPage,
    type: payload?.type,
    program: payload?.program,
    parent_id: payload?.parent_id,
    gender: payload?.gender,
  };
  try {
    return await axios.get(`${API_URL}/admin/apprenticeship-program/vetting-pool-applicant-details/list`, { params: query, headers });
  } catch (err) {
    throw new Error(err);
  }
};

export const updateApplicationStatus = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('token')}`,
    organisationid: ls.get('orgId'),
  };
  try {
    const response = await axios.post(`${API_URL}/admin/apprenticeship-program/registered-applicant-status/update`, payload, { headers });
    return response;
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const getTrainingProviderList = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('token')}`,
    organisationid: ls.get('orgId'),
  };
  const query = {
    search: payload.search ? payload.search : '',
  };
  try {
    return await axios.get(`${API_URL}/admin/apprenticeship-program/child-organisation-list/${payload?.programId}`, { params: query, headers });
  } catch (err) {
    throw new Error(err);
  }
};

export const assignedTrainingProvider = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('token')}`,
    organisationid: ls.get('orgId'),
  };
  try {
    const response = await axios.post(`${API_URL}/admin/apprenticeship-program/apprenticeship-registration-flow/assigned-training-provider`, payload, { headers });
    return response;
  } catch (err) {
    if (err.response && err.response.data) {
      return { error: true, message: err.response.data.message || 'Unknown error', details: err.response.data };
    }
    return { error: true, message: err.message || 'Network error' };
  }
};

export const getMyApplicants = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('token') || payload?.token}`,
    organisationid: ls.get('orgId') || payload.orgId,
  };
  const query = {
    search: payload.search_keyword ? payload.search_keyword : '',
    sort: payload.sort,
    sortBy: payload.sortBy,
    currentPage: payload.currentPage,
    perPage: payload.perPage,
    type: payload?.type,
    program: payload?.program,
    idp_id: payload?.idp_id,
    parent_id: payload?.parent_id,
  };
  try {
    return await axios.get(`${API_URL}/admin/apprenticeship-program/training-provider-assigned-applicant/list`, { params: query, headers });
  } catch (err) {
    throw new Error(err);
  }
};

export const userCreate = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('token')}`,
    organisationid: ls.get('orgId'),
  };
  try {
    const response = await axios.post(`${API_URL}/admin/apprenticeship-program/apprenticeship-registration-flow/create-user`, payload, { headers });
    return response;
  } catch (err) {
    if (err.response && err.response.data) {
      return { error: true, message: err.response.data.message || 'Unknown error', details: err.response.data };
    }
    return { error: true, message: err.message || 'Network error' };
  }
};
